import StopPaymentPage from "components/pages/StopPaymentPage";

export default function CaptureStopPaymentStopPayment(props) {
    return <StopPaymentPage />
}